import { debugLogger } from '../../../../helper/debugLogger';
import { createFileFromUrl } from '../../../../helper/fileHelper';
import { useUploadMediaMutation } from './media-api';

export const useSignedUploadMedia = () => {
  const { mutateAsync, isPending } = useUploadMediaMutation();

  const uploadSignedMedia = async (imageUrl: string, currentUserId: string) => {
    if (!imageUrl) {
      return null;
    }

    try {
      const fileName = `${currentUserId}_${Date.now()}.png`;
      const file = await createFileFromUrl(imageUrl, fileName, 'image/png');
      const uploadResponse = await mutateAsync({
        form: {
          file,
        },
      });

      if (uploadResponse?.imageUrl) {
        return encodeURI(uploadResponse.imageUrl);
      }
    } catch (error) {
      debugLogger('Error during upload:', error);
    }

    return null;
  };

  return { uploadSignedMedia, isProcessing: isPending };
};
